import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";

import { SortingRequestParams } from "../../shared/types/api-types";
import { SORT_DIRECTIONS } from "../../shared/types/sort";

import { getOrders, GetOrdersFilter } from "./api";
import {
  ORDER_LIST_QUERY_KEY,
  ORDER_LIST_SORT_FIELDS,
  ORDERS_COUNT_PER_PAGE,
} from "./constants";
import { OrderSortColumn } from "./types";

export const DEFAULT_ORDER_LIST_SORTING: SortingRequestParams<OrderSortColumn> =
  {
    columnName: ORDER_LIST_SORT_FIELDS.createdAt,
    direction: SORT_DIRECTIONS.desc,
  };

interface GetInfiniteOrdersQueryOptionsParams {
  filter?: GetOrdersFilter;
  sorting?: SortingRequestParams<OrderSortColumn>;
}

export const getInfiniteOrdersQueryOptions = ({
  filter = {},
  sorting = DEFAULT_ORDER_LIST_SORTING,
}: GetInfiniteOrdersQueryOptionsParams = {}) =>
  infiniteQueryOptions({
    queryKey: [ORDER_LIST_QUERY_KEY, filter, sorting],
    queryFn: ({ pageParam }) =>
      getOrders({
        ...filter,
        sorting,
        pagination: {
          page: pageParam,
          countPerPage: ORDERS_COUNT_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) =>
      lastPage.pagination?.hasMore
        ? lastPage.pagination.currentPage + 1
        : undefined,
    initialPageParam: 1,
    placeholderData: keepPreviousData,
  });
